// AI Generated File
import { Component, Input } from '@angular/core';

@Component({
    selector: 'statistics-information',
    templateUrl: './statistics-information.component.html',
    standalone: false,
})
export class StatisticsInformationComponent {
    @Input() title?: string;
    @Input() value?: string;
    @Input() noRuler: boolean = true;

    constructor () {}
}
